/* eslint-disable */
import apiHelper from '@utils/cunstomInterseptor'


function convertTime (time) {
  const data = time;
  const milliseconds = Math.floor(Number(data) * 1000);
  const date = new Date(milliseconds);
  const month = String(date.getMonth() + 1).padStart(2, '0');
  const day = String(date.getDate()).padStart(2, '0');
  const hours = String(date.getHours()).padStart(2, '0');
  const minutes = String(date.getMinutes()).padStart(2, '0');
  const seconds = String(date.getSeconds()).padStart(2, '0');
  const year = date.getFullYear().toString().slice(2);
  return `${day}.${month}.${year}, ${hours}:${minutes}:${seconds}`
}

export const state = {
  amlinc: [],
  lymit: [],
  amlout: [],
  amlouterror: [],
  amlincerror: [],
  isConnected: false,
  ws: null,
  deviceId: null,
  lastEventId: 0
};

export const mutations = {
  CLEAR_INTERVAL(state) {
    if (state.pingInterval) {
      clearInterval(state.pingInterval);
      state.pingInterval = null;
    }
  },
  SET_INTERVAL(state, intervalId) {
    state.pingInterval = intervalId;
  },
  SET_AML_INC_NOTIFICATION(state, data) {
    state.amlinc.push(data);
    state.amlinc = state.amlinc.filter((value, index, self) =>
      index === self.findIndex((t) => t.notif_id === value.notif_id)
    )
    state.amlinc.sort((a, b) => {
      const parseDate = str => {
        const [date, time] = str.split(', ')
        const [day, month, year] = date.split('.')
        return new Date(`20${year}-${month}-${day}T${time}`)
      };

      return parseDate(b.timeStamp) - parseDate(a.timeStamp)
    })
  },
  SET_LYMIT_NOTIFICATION(state, data) {
    state.lymit.push(data);
    state.lymit = state.lymit.filter((value, index, self) =>
      index === self.findIndex((t) => t.notif_id === value.notif_id)
    )
    state.lymit.sort((a, b) => {
      const parseDate = str => {
        const [date, time] = str.split(', ')
        const [day, month, year] = date.split('.')
        return new Date(`20${year}-${month}-${day}T${time}`)
      };

      return parseDate(b.timeStamp) - parseDate(a.timeStamp)
    })
  },
  SET_ERROR_INC_NOTIFICATION(state, data) {
    state.amlincerror.push(data);
    state.amlincerror = state.amlincerror.filter((value, index, self) =>
      index === self.findIndex((t) => t.notif_id === value.notif_id)
    )
    state.amlincerror.sort((a, b) => {
      const parseDate = str => {
        const [date, time] = str.split(', ')
        const [day, month, year] = date.split('.')
        return new Date(`20${year}-${month}-${day}T${time}`)
      };

      return parseDate(b.timeStamp) - parseDate(a.timeStamp)
    })
  },
  SET_ERROR_OUT_NOTIFICATION(state, data) {
    state.amlouterror.push(data);
    state.amlouterror = state.amlouterror.filter((value, index, self) =>
      index === self.findIndex((t) => t.notif_id === value.notif_id)
    )
    state.amlouterror.sort((a, b) => {
      const parseDate = str => {
        const [date, time] = str.split(', ')
        const [day, month, year] = date.split('.')
        return new Date(`20${year}-${month}-${day}T${time}`)
      };

      return parseDate(b.timeStamp) - parseDate(a.timeStamp)
    })
  },
  SET_AML_OUT_NOTIFICATION(state, data) {
    state.amlout.push(data);
    state.amlout = state.amlout.filter((value, index, self) =>
      index === self.findIndex((t) => t.notif_id === value.notif_id)
    )
    state.amlout.sort((a, b) => {
      const parseDate = str => {
        const [date, time] = str.split(', ')
        const [day, month, year] = date.split('.')
        return new Date(`20${year}-${month}-${day}T${time}`)
      };

      return parseDate(b.timeStamp) - parseDate(a.timeStamp)
    })
  },
  CLEAR_NOTIFICATIONS(state) {
    state.amlout = [];
    state.lymit = [];
    state.amlinc = [];
    state.amlouterror = [];
    state.amlincerror = [];
  },
  DELETE_LYMIT(state, id) {
    state.lymit = state.lymit.filter(el => el.notif_id !== id);
  },
  DELETE_AML_INC(state, id) {
    state.amlinc = state.amlinc.filter(el => el.notif_id !== id);
  },
  DELETE_AML_OUT(state, id) {
    state.amlout = state.amlout.filter(el => el.notif_id !== id);
  },
  DELETE_ERROR_INC(state, id) {
    state.amlincerror = state.amlincerror.filter(el => el.notif_id !== id);
  },
  DELETE_ERROR_OUT(state, id) {
    state.amlouterror = state.amlouterror.filter(el => el.notif_id !== id);
  },
  DELETE_DEAD_NOTIFICATIONS (state, ids) {
    state.amlinc = state.amlinc.filter(el => !ids.includes(el.notif_id))
    state.amlout = state.amlout.filter(el => !ids.includes(el.notif_id))
    state.lymit = state.lymit.filter(el => !ids.includes(el.notif_id))
    state.amlouterror = state.amlouterror.filter(el => !ids.includes(el.notif_id))
    state.amlincerror = state.amlincerror.filter(el => !ids.includes(el.notif_id))
  },
  SET_CONNECTION_STATUS(state, data) {
    state.isConnected = data
  },
  SET_LAST_EVENT(state, data) {
    state.lastEventId = data
  },
  SET_WS(state, ws) {
    state.ws = ws;
  },
};

export const actions = {
  async deleteNotificationById({ commit, rootState }, obj) {
    if (obj.type === 1) {
      apiHelper.delete(`/delete_notification/${obj.notif_id}`)
      commit("DELETE_LYMIT", obj.notif_id)
    }
    if (obj.type === 2) {
      apiHelper.delete(`/delete_notification/${obj.notif_id}`)
      commit("DELETE_AML_INC", obj.notif_id)
    }
    if (obj.type === 3) {
      apiHelper.delete(`/delete_notification/${obj.notif_id}`)
      commit("DELETE_AML_OUT", obj.notif_id)
    }
    if (obj.type === -1) {
      apiHelper.delete(`/delete_notification/${obj.notif_id}`)
      commit("DELETE_ERROR_INC", obj.notif_id)
    }
    if (obj.type === -2) {
      apiHelper.delete(`/delete_notification/${obj.notif_id}`)
      commit("DELETE_ERROR_OUT", obj.notif_id)
    }
  },

  async getExistMessages({commit, rootState}) {
    const { data } = await apiHelper.get(`/get_notifications`)
    if (data && data.notifications) {
      for (let i = 0; i < data.notifications.length; i++) {
        if (data.notifications[i].type === 1) {
          data.notifications[i].data.timeStamp = convertTime(data.notifications[i].created_at)
          data.notifications[i].data.type = data.notifications[i].type
          data.notifications[i].data.id = data.notifications[i].id
          data.notifications[i].data.notif_id = data.notifications[i].id
          commit("SET_LYMIT_NOTIFICATION", data.notifications[i].data);
        } else if (data.notifications[i].type === 2) {
          data.notifications[i].data.timeStamp = convertTime(data.notifications[i].created_at)
          data.notifications[i].data.type = data.notifications[i].type
          data.notifications[i].data.notif_id = data.notifications[i].id
          commit('SET_AML_INC_NOTIFICATION', data.notifications[i].data)
        } else if (data.notifications[i].type === 3) {
          data.notifications[i].data.timeStamp = convertTime(data.notifications[i].created_at)
          data.notifications[i].data.type = data.notifications[i].type
          data.notifications[i].data.notif_id = data.notifications[i].id
          commit("SET_AML_OUT_NOTIFICATION", data.notifications[i].data);
        } else if (data.notifications[i].type === -1) {
          data.notifications[i].data.timeStamp = convertTime(data.notifications[i].created_at)
          data.notifications[i].data.type = data.notifications[i].type
          data.notifications[i].data.notif_id = data.notifications[i].id
          commit('SET_ERROR_INC_NOTIFICATION', data.notifications[i].data)
        } else if (data.notifications[i].type === -2) {
          data.notifications[i].data.timeStamp = convertTime(data.notifications[i].created_at)
          data.notifications[i].data.type = data.notifications[i].type
          data.notifications[i].data.notif_id = data.notifications[i].id
          commit('SET_ERROR_OUT_NOTIFICATION', data.notifications[i].data)
        }
      }
    }
    if (data.last_event_id) {
      commit('SET_LAST_EVENT', data.last_event_id)
    }
  },
  async getAMLMessages({ commit, state, dispatch, rootState }) {
    if (state.isConnected) return;

    dispatch("disconect");
    if (state.ws) {
      state.ws.removeEventListener("open", state.ws._openHandler);
      state.ws.removeEventListener("message", state.ws._messageHandler);
      state.ws.removeEventListener("close", state.ws._closeHandler);
    }

    if (!sessionStorage.getItem('device_id')) {
      sessionStorage.setItem('device_id', Date.now())
    }

    const ws = new WebSocket(
      `${process.env.USDT_WEBSOCKET_LISTENER}/ws_notifications`
    );

    function open() {
      commit("SET_WS", ws);
      commit("SET_CONNECTION_STATUS", true)
      console.log("open");
      const tokenC = sessionStorage.getItem('token')
      const messageToSend = {
        type: "initialRequest",
        token: tokenC,
        device_id: String(JSON.parse(sessionStorage.getItem('device_id'))),
        last_event_id: state.lastEventId,
      };
      state.ws.send(JSON.stringify(messageToSend));
      const intervalId = setInterval(() => {
        const pingMessage = { token: tokenC };
        state.ws.send(JSON.stringify(pingMessage));
      }, 25000);

      commit("SET_INTERVAL", intervalId);
    }
    function message(event) {
      const data = JSON.parse(event.data);
      if (data === 401) {
        dispatch("disconect");
        dispatch('LOG_OUT')
      }
      if (data.last_event_id > state.lastEventId) {
        commit('SET_LAST_EVENT', data.last_event_id)
        state.ws.send(JSON.stringify({type: 'ack', payload: {last_event_id: data.last_event_id}}));
        const notifications = data.notifications
        commit('DELETE_DEAD_NOTIFICATIONS', data.deleted_ids)
        for (let i = 0; i < notifications.length; i++) {
          if (notifications[i].type === 1) {
            notifications[i].data.timeStamp = convertTime(notifications[i].created_at)
            notifications[i].data.type = notifications[i].type
            notifications[i].data.id = notifications[i].id
            notifications[i].data.notif_id = notifications[i].id
            commit("SET_LYMIT_NOTIFICATION", notifications[i].data);
          } else if (notifications[i].type === 2) {
            notifications[i].data.timeStamp = convertTime(notifications[i].created_at)
            notifications[i].data.type = notifications[i].type
            notifications[i].data.notif_id = notifications[i].id
            commit("SET_AML_INC_NOTIFICATION", notifications[i].data);
          } else if (notifications[i].type === 3) {
            notifications[i].data.timeStamp = convertTime(notifications[i].created_at)
            notifications[i].data.type = notifications[i].type
            notifications[i].data.notif_id = notifications[i].id
            commit("SET_AML_OUT_NOTIFICATION", notifications[i].data);
          } else if (notifications[i].type === -1) {
            notifications[i].data.timeStamp = convertTime(notifications[i].created_at)
            notifications[i].data.type = notifications[i].type
            notifications[i].data.notif_id = notifications[i].id
            commit('SET_ERROR_INC_NOTIFICATION', notifications[i].data)
          } else if (notifications[i].type === -2) {
            notifications[i].data.timeStamp = convertTime(notifications[i].created_at)
            notifications[i].data.type = notifications[i].type
            notifications[i].data.notif_id = notifications[i].id
            commit('SET_ERROR_OUT_NOTIFICATION', notifications[i].data)
          }
        }
      }
    }

    function close() {
      console.log("close");
      commit("SET_CONNECTION_STATUS", false);
      commit("CLEAR_INTERVAL");
      setTimeout(() => {
        dispatch("getAMLMessages");
      }, 10000);
    }

    ws._openHandler = open;
    ws._messageHandler = message;
    ws._closeHandler = close;
    ws.addEventListener("open", open);
    ws.addEventListener("message", message);
    ws.addEventListener("close", close);

    commit("CLEAR_INTERVAL");
   
  },
  disconect({ commit }) {
    if (state.ws) {
      state.ws.close();
      state.ws.removeEventListener("open", state.ws._openHandler);
      state.ws.removeEventListener("message", state.ws._messageHandler);
      state.ws.removeEventListener("close", state.ws._closeHandler);
      commit("SET_WS", null);
    }
  }
};

export const getters = {
  getUnreadLymit: state => state.lymit,
  getUnreadInc: state => state.amlinc,
  getUnreadOut: state => state.amlout,
  getUnreadErrorInc: state => state.amlincerror,
  getUnreadErrorOut: state => state.amlouterror,
  getConnectionStatus: state => state.isConnected
};

export default {
  state,
  mutations,
  actions,
  getters
};



// WEBPACK FOOTER //
// ./src/vuex/modules/amlNotification.module.js